import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import "./index.scss";

import Pagination from '../../../ui/Pagination';
import SideModal from '../../../ui/SideModal';
import { toaster } from "../../../ui/Toaster";
import NoDataFound from "../../../ui/NoDataFound";
import DropDown from "../../../ui/DropDown";
import RadioButton from "../../../ui/RadioButton";
import Button from "../../../ui/Button";
import SkeletonLoader from "../../../ui/SkeletonLoader";

import SubDomains from '../../../PostLogin/DomainDetails/AssetsTab/SubDomains';
import IpAddress from '../../../PostLogin/DomainDetails/AssetsTab/IpAddress';
import Emails from '../../../PostLogin/DomainDetails/AssetsTab/Emails';
import AddDomain from "../../../PostLogin/OrganizationDetails/AddDomain";

import { filterIcon, filterCloseIcon, assetInventoryIncludeIcon, assetInventoryExcludeIcon, searchIcon } from "../../../../utils/icons";

import { useSelector, useDispatch } from 'react-redux';
import { getAssetInventorySubdomain, 
        getAssetInventoryIPAddress, 
        getAssetInventoryEmails, 
        subDomainInclude, 
        subDomainExclude,
        ipAddressInclude,
        ipAddressExclude,
        emailInclude,
        emailExclude,
        resetIncludeExcludeResponse,
        } from '../../../../store/actions/domainAction';

const statusOption = [
    {
        label: "Included",
        value: "included"
    },
    {
        label: "Excluded",
        value: "excluded"
    }
]

const filterRadioOption = [    
    {
        label: "Ascending",
        value: "asc"
    },
    {
        label: "Descending",
        value: "desc"
    }
]

const AssetsTab = ({doaminData}) => {

    const subDomainListResponse = useSelector((state) => state.domain?.assetInventorySubdomainList);
    const ipAddressListResponse = useSelector((state)=> state.domain?.assetInventoryIpAddressList);
    const emailListResponse = useSelector((state)=> state.domain?.assetInventoryEmailList);
    const subDomainIncludeResponse = useSelector((state)=> state.domain?.subDomainIncludeResponse);
    const subDomainExcludeResponse = useSelector((state) => state.domain?.subDomainExcludeResponse);
    const ipAddressIncludeResponse = useSelector((state) => state.domain?.ipAddressIncludeResponse);
    const ipAddressExcludeResponse = useSelector((state) => state.domain?.ipAddressExcludeResponse);
    const emailIncludeResponse = useSelector((state) => state.domain?.emailIncludeResponse);
    const emailExcludeResponse = useSelector((state) => state.domain?.emailExcludeResponse);

    const dispatch = useDispatch();

    const { t } = useTranslation();

    const filterWrapperRef = useRef(null);

    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);
    // filter value
    const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedSortby, setSelectedSortby] = useState("");
    const [selectedSortOrder, setSelectedSortOrder] = useState("");
    const [showFilter, setShowFilter] = useState(false);

    // selected filter value
    const [filterSelectedStatus, setFilterSelectedStatus] = useState("");
    const [filterSelectedSortby, setFilterSelectedSortby] = useState("");
    const [filterSelectedSortOrder, setFilterSelectedSortOrder] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [activeTab, setActiveTab] = useState("subdomains");

   
    const [showAdddomainSidePanel, setShowAdddomainSidePanel] = useState(false);

    const [selectedDomainList, setSelectedDomainList] = useState([]);
    const [selectedIpAddressesList, setSelectedIpAddressesList] = useState([]);
    const [selectedEmailList, setSelectedEmailList] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [tabelData, setTabelData] = useState(null);

    const handleCheckboxChange = (value) => {
        if (activeTab === "subdomains") {
            setSelectedDomainList(value);
        } else if (activeTab === "ipAddress") {
            setSelectedIpAddressesList(value);
        } else if (activeTab === "mails") {
            setSelectedEmailList(value);
        }
    };

    const getSelectedLabel = () => {
        if (activeTab === "subdomains" && selectedDomainList.length > 0) {
            return `${selectedDomainList.length} Sub-Domains selected`;
        }
        if (activeTab === "ipAddress" && selectedIpAddressesList.length > 0) {
            return `${selectedIpAddressesList.length} IP Addresses selected`;
        }
        if (activeTab === "mails" && selectedEmailList.length > 0) {
            return `${selectedEmailList.length} Emails selected`;
        }
        return null;
    };

    const changeActiveTab = (value) => {
        setSearchValue("")
        setSearchQuery("")
        setCurrentPageSize(10);
        setCurrentPage(1);
        setSelectedDomainList([]);
        setSelectedIpAddressesList([]);
        setSelectedEmailList([]);
        removeFilter("status");     
        removeFilter("sortorder");     
        removeFilter("sortby");  
        setActiveTab(value);  
    }

    const filterClicked = () => {
        setShowFilter(true);
    };

    const closeAddDomainSidePanel = () => {
        setShowAdddomainSidePanel(false);
    };

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const removeFilter = (type) => {
        setCurrentPage(1);
        if(type === "status") {
            setSelectedStatus("")
            setFilterSelectedStatus("")
        } else if (type === "sortorder") {
            setSelectedSortOrder("");
            setFilterSelectedSortOrder("")
        } else if (type === "sortby") {
            setSelectedSortby("");
            setSelectedSortOrder("");
            setFilterSelectedSortby("");
            setFilterSelectedSortOrder("");
        }
    }

    const applyFilter = () => {
        setCurrentPage(1);
        setFilterSelectedStatus(selectedStatus)
        setFilterSelectedSortby(selectedSortby)
        setFilterSelectedSortOrder(selectedSortOrder)
        setShowFilter(false)        
    }

    const getSortByOptions = () => {
        if (activeTab === "subdomains") {
            return [
                { label: "Subdomain", value: "subdomain" },
                { label: "Client Provided", value: "client_provided" },
                { label: "First Seen", value: "first_seen" },
                { label: "Last Seen", value: "last_seen" }
            ];
        }
        if (activeTab === "ipAddress") {
            return [
                { label: "IP Address", value: "ip_address" },
                { label: "Client Provided", value: "client_provided" },
                { label: "First Seen", value: "first_seen" },
                { label: "Last Seen", value: "last_seen" }
            ];
        }
        if (activeTab === "mails") {
            return [
                { label: "Email", value: "email" },
                { label: "Client Provided", value: "client_provided" },
                { label: "First Seen", value: "first_seen" },
                { label: "Last Seen", value: "last_seen" }
            ];
        }
        return [];
    };

    const displaySortByName = (type) => {
        if (type === "status") {
            const matchedOption = statusOption.find((data) => data.value === selectedStatus)
            return matchedOption ? matchedOption.label : "";
        } else if (type === "sortOrder") {
            const matchedOption = filterRadioOption.find((data) => data.value === selectedSortOrder)
            return matchedOption ? matchedOption.label : "";
        } else {
            const matchedOption = getSortByOptions().find((data) => data.value === selectedSortby)
            return matchedOption ? matchedOption.label : "";
        }
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setSearchQuery(searchValue)
        setCurrentPageSize(10);
        setCurrentPage(1);
    }

    const isDisableButton = () => {
        const activeList = {
            subdomains: selectedDomainList,
            ipAddress: selectedIpAddressesList,
            mails: selectedEmailList
        };
    
        return (activeList[activeTab]?.length || 0) === 0;
    }

    const includeList = () => {
        let obj = {
            domain: doaminData.domain,
        }
        if (activeTab === "subdomains") {
            obj.subdomains = selectedDomainList.map((data)=>{
                return data.subdomain
            })
            dispatch(subDomainInclude(obj))
        }
        if (activeTab === "ipAddress") {
            obj.ip_addresses = selectedIpAddressesList.map((data)=>{
                return data.ip_address
            })
            dispatch(ipAddressInclude(obj))
        }
        if (activeTab === "mails") {
            obj.emails = selectedEmailList.map((data)=>{
                return data.email
            })
            dispatch(emailInclude(obj))
        }
    }

    const excludeList = () => {
        let obj = {
            domain: doaminData.domain,
        }
        if (activeTab === "subdomains") {
            obj.subdomains = selectedDomainList.map((data)=>{
                return data.subdomain
            })
            dispatch(subDomainExclude(obj))
        }
        if (activeTab === "ipAddress") {
            obj.ip_addresses = selectedIpAddressesList.map((data)=>{
                return data.ip_address
            })
            dispatch(ipAddressExclude(obj))
        }
        if (activeTab === "mails") {
            obj.emails = selectedEmailList.map((data)=>{
                return data.email
            })
            dispatch(emailExclude(obj))
        }
    }

    const fetchTabelData = useCallback (()=> {
        if(doaminData != null) {
            const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}&domain=${doaminData?.domain}`;
            const queryParams = searchQuery ? `&query=${searchQuery}` : "";
            const sortParams = (filterSelectedStatus ? `&excluded=${filterSelectedStatus === "excluded" ? true : false}` : '') + (filterSelectedSortby ? `&sort_by=${filterSelectedSortby}` : '') + (filterSelectedSortOrder ? `&sort_order=${filterSelectedSortOrder}` : '');
            const url = `${baseUrl}${queryParams}${sortParams}`;
            setIsLoading(true)
            if (activeTab === "subdomains") {
                dispatch(getAssetInventorySubdomain(url))
            } else if (activeTab === "ipAddress") {
                dispatch(getAssetInventoryIPAddress(url))
            } else {
                dispatch(getAssetInventoryEmails(url))
            }
        }
    },[dispatch, doaminData, currentPage, currentPageSize, activeTab, searchQuery, filterSelectedStatus, filterSelectedSortby, filterSelectedSortOrder])

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if (showFilter) {
                    setShowFilter(false);
                }
            }
        }
    }, [showFilter]);

    useEffect(()=>{

        fetchTabelData()

    },[fetchTabelData, currentPage, currentPageSize, activeTab, searchQuery])

    useEffect(()=>{
        
        if (activeTab === "subdomains" && subDomainListResponse != null) {
            setIsLoading(false)
            setTabelData(subDomainListResponse);
        } else if (activeTab === "ipAddress" && ipAddressListResponse != null) {
            setIsLoading(false)
            setTabelData(ipAddressListResponse);
        } else if(activeTab === "mails" && emailListResponse != null) {
            setIsLoading(false)
            setTabelData(emailListResponse);
        }

    },[activeTab, subDomainListResponse, ipAddressListResponse, emailListResponse])

    useEffect(()=>{
        const handleResponse = (response, type) => {
            if (response) {
                if (response?.status === "failed") {
                    toaster.addToast(response?.description, "error");
                } else {
                    fetchTabelData();
                    clearSelections();
                    toaster.addToast(response?.detail?.description, "success");
                }
                dispatch(resetIncludeExcludeResponse());
            }
        };

        const clearSelections = () => {
            setSelectedDomainList([]);
            setSelectedIpAddressesList([]);
            setSelectedEmailList([]);
        };

        handleResponse(subDomainIncludeResponse, "subDomainInclude");
        handleResponse(subDomainExcludeResponse, "subDomainExclude");
        handleResponse(ipAddressIncludeResponse, "ipAddressInclude");
        handleResponse(ipAddressExcludeResponse, "ipAddressExclude");
        handleResponse(emailIncludeResponse, "emailInclude");
        handleResponse(emailExcludeResponse, "emailExclude");

        
    },[fetchTabelData, dispatch, subDomainIncludeResponse, subDomainExcludeResponse, ipAddressIncludeResponse, ipAddressExcludeResponse, emailIncludeResponse, emailExcludeResponse])

    return (
        <>
            <div className="assets-container d-flex my-4">
                <p className={`text-center pointer ${activeTab === "subdomains" ? "active" : ""}`} onClick={() => changeActiveTab("subdomains")}>Subdomains</p>
                <p className={`text-center pointer ${activeTab === "ipAddress" ? "active" : ""}`} onClick={() => changeActiveTab("ipAddress")}>IP Address</p>
                <p className={`text-center pointer ${activeTab === "mails" ? "active" : ""}`} onClick={() => changeActiveTab("mails")}>Emails</p>
            </div>

            <div className="search-filter-container my-3 d-flex justify-content-between align-items-center">
                <div className="search-container d-flex align-items-center gap-3">
                    <div className="position-relative" onKeyDown={handleSearchKeyDown}>
                        <input className="search-input rounded" 
                            placeholder={`${activeTab === "subdomains" ? "Search Subdomain" : activeTab === "ipAddress" ? "Search IP Address" : "Search Email"}`} 
                            value={searchValue} 
                            onChange={(e) => {setSearchValue(e.target.value)}} 
                            onFocus={() => setIsSearchFocused(true)}
                            onBlur={() => setIsSearchFocused(false)}
                            />
                        <span className="position-absolute search-icon" >{searchIcon()}</span>
                    </div>
                    <button className="search-btn" onClick={onSearch}>{t("organizationDetailsPage.searchBtn")}</button>
                    <div className="position-relative">
                        <span className="filter-icon" onClick={filterClicked}>{filterIcon()}</span>
                        {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>                                
                            <h6>Status</h6>
                                <DropDown 
                                    placeHolder={"Sort By"}
                                    options={statusOption}
                                    isMulti={false}
                                    isSearchable={false}
                                    onChange={(data)=>{setSelectedStatus(data.value)}}
                                    defaultSelectedValue={selectedStatus}
                                />
                            <h6 className="mt-4">Sort By</h6>
                                <DropDown 
                                    placeHolder={"Sort By"}
                                    options={getSortByOptions()}
                                    isMulti={false}
                                    isSearchable={false}
                                    onChange={(data)=>{setSelectedSortby(data.value)}}
                                    defaultSelectedValue={selectedSortby}
                                />
                            <h6 className="mt-4">Sort Order</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    filterRadioOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(data)=>{setSelectedSortOrder(data)}} key={index} isChecked={data.value === selectedSortOrder} />
                                        )
                                    })
                                }
                            </div>
                            <div className="filter-apply-btn mt-3">
                                <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={false} buttonClicked={()=>{applyFilter()}}/>
                            </div>
                        </div>}
                    </div>
                    {!showFilter && <p className="selected-filters">
                        {filterSelectedStatus !== "" && <span className="d-inline-block mx-2">{displaySortByName("status")} <span onClick={() => removeFilter("status")}>{filterCloseIcon()}</span></span>}
                        {filterSelectedSortby !== "" && <span className="d-inline-block mx-2">{displaySortByName("sortby")} <span onClick={() => removeFilter("sortby")}>{filterCloseIcon()}</span></span>}
                        {filterSelectedSortOrder !== "" && <span className="d-inline-block mx-2">{displaySortByName("sortOrder")} <span onClick={() => removeFilter("sortorder")}>{filterCloseIcon()}</span></span>}
                    </p>}
                </div>
                <div className="sort-edit-container">
                    <div className="container d-flex gap-3 align-items-center">
                        {getSelectedLabel() && (
                            <button className="borderless-btn">
                                {getSelectedLabel()}
                            </button>
                        )}

                        <button className='bg-white' disabled={isDisableButton()} onClick={includeList}>
                            <span className="d-inline-block mx-1">{assetInventoryIncludeIcon()}</span>
                            {t("domainDetailsPage.includeBtn")}

                        </button>
                        <button className='bg-white' disabled={isDisableButton()} onClick={excludeList}>
                            <span className="d-inline-block mx-1">{assetInventoryExcludeIcon()}</span>
                            {t("domainDetailsPage.excludeBtn")}
                        </button>
                    </div>
                </div>
            </div>

            <div className="domain-table-container">
                {
                    isLoading ? 
                        <SkeletonLoader type={"line"} count={5} currentPage={"assetInventory"} />                         
                    :
                    <>
                        {activeTab === "subdomains" && <SubDomains onCheckboxChange={(value) => handleCheckboxChange(value)} subDomainList={subDomainListResponse} />}
                        {activeTab === "ipAddress" && <IpAddress onCheckboxChange={(value) => handleCheckboxChange(value)} ipAddressList={ipAddressListResponse} />}
                        {activeTab === "mails" && <Emails onCheckboxChange={(value) => handleCheckboxChange(value)} emailList={emailListResponse} />}
                        {tabelData !== null && !isLoading && tabelData?.meta?.total_results > 0 && <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            pageSize={currentPageSize}
                            totalCount={tabelData?.meta?.total_results || 0}
                            onPageChange={setCurrentPageandRecordSize}
                        />}
                    </>
                }
                {
                    !isLoading && tabelData?.meta?.total_results === 0 &&
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        <NoDataFound />
                    </motion.div>
                }
            </div>
            <SideModal showSidePanel={showAdddomainSidePanel} hideSidePanel={closeAddDomainSidePanel}>
                {showAdddomainSidePanel && <AddDomain />}
            </SideModal>
        </>
    )
}

export default AssetsTab;
